import { IOrgInterForm } from '../../../../../../../modules/types/OrgInterForm';

export const defaultOrgInterFormMain: IOrgInterForm = {
  id: 0,
  statusOrgInter: 0,
  componenteAf: 0,
  numeroTC: '',
  numeroTermoAjuste: '',
  nupTermoAjuste: '',
  dataInicio: '',
  dataVigencia: '',
  orgInternacional: 162,
  observacoes: '',
};
